import React from 'react'
import {FormattedMessage} from 'react-intl'
import Facebook from '../../assets/brands/Facebook.svg'
import Line from '../../assets/brands/Line.svg'
import Twitter from '../../assets/brands/Twitter.svg'
import styles from './PostPreview.scss'

const SNS = ({post, url}: {post: {summary: string}, url: string}) => {
  const {summary} = post
  return <div className={[styles.snsContainer, 'row m-0 d-flex justify-content-stretch'].join(' ')}>
    <div className="col-4 pl-0 pr-2">
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${ encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        className={['btn mt-2', styles.facebook].join(' ')}
      >
        <Facebook className="fa font-size-2x"/>
        <span className="ml-2 d-none d-md-inline-block">
          <FormattedMessage defaultMessage="Share" id="post.share"/>
        </span>
      </a>
    </div>
    <div className="col-4 px-1">
      <a
        href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(summary)}&url=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        className={['btn mt-2', styles.twitter].join(' ')}
      >
        <Twitter className="fa font-size-2x"/>
        <span className="ml-2 d-none d-md-inline-block">
          <FormattedMessage defaultMessage="Tweet" id="post.tweet"/>
        </span>
      </a>
    </div>
    <div className="col-4 pr-0 pl-2">
      <a
        href={`http://line.me/R/msg/text/?${ encodeURIComponent(url) }`}
        target="_blank"
        rel="noopener noreferrer"
        className={['btn mt-2 py-1', styles.line].join(' ')}
      >
        <Line className="fa font-size-2x"/>
        <span className="ml-2 d-none d-md-inline-block">
          LINE
        </span>
      </a>
    </div>
  </div>
}
SNS.displayName = 'SNS'
export default SNS
